export function getMtcaLevels(conflicts, minTime, maxTime) {
    const level1Conflicts = [];
    const level2Conflicts = [];
    if (typeof minTime === "undefined" || typeof maxTime === "undefined" || maxTime < Date.now()) {
        return { level1Pairs: level1Conflicts, level2Pairs: level2Conflicts };
    }
    for (const conflict of conflicts) {
        const { conflictA, conflictB } = conflict;
        if (minTime <= conflictA.segment.endTime && conflictA.segment.startTime <= maxTime && conflictA.segment.minimumDistance <= 5
            && minTime <= conflictB.segment.endTime && conflictB.segment.startTime <= maxTime && conflictB.segment.minimumDistance <= 5) {
            level1Conflicts.push(conflict);
        }
        else if (minTime <= conflictA.segment.endTime && conflictA.segment.startTime <= maxTime && conflictA.segment.minimumDistance <= 12
            && minTime <= conflictB.segment.endTime && conflictB.segment.startTime <= maxTime && conflictB.segment.minimumDistance <= 12) {
            level2Conflicts.push(conflict);
        }
    }
    return { level1Conflicts, level2Conflicts };
}
//# sourceMappingURL=trajectory.js.map